export const environment = {
  production: true,
  periode: 6000000000000,
  //api_url: location.origin + '/CartePetroliere'

  api_url: location.origin + '/WSPortailStarOil',
  //api_url: location.origin + '/BackStaroilDemo'
 //  api_url:  'https://192.168.1.43:3443/BackStarOilClean',

  //api_url:"http://localhost:57660",

 //api_url:"https://localhost:44312"
  firebase: {
    apiKey: "AIzaSyAD8cWEy2_QsuxjYOE4DzXvmVFdkEoJFCM",
    authDomain: "staroil-6e5d3.firebaseapp.com",
    projectId: "staroil-6e5d3",
    storageBucket: "staroil-6e5d3.firebasestorage.app",
    messagingSenderId: "809001929486",
    appId: "1:809001929486:web:088dd60215f6b7387de55f",
    measurementId: "G-N73KJQ83K4"
  },
  vapidKey: 'BAyGC9s92YihFatPDKrmn3gbzrERYEbX_QNBn-7k6rPBFB0I3PfBq6p_5NnanJmNF7uOMNVYxzfxWvVroduhLE4',
  enableSpecialFeature: true,

};